import React from 'react';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import Alert from 'app-ui-componentlibrary/dist/componentLibrary/layout/Alert';

export default Alert;
export const ConfigAlert = connectDynamic(Alert);
